import React, { useState } from 'react';
import ButtonMore from '../../../components/Buttons/ButtonMore';
import { useScreenSize } from '../../../hooks/useScreenSize';

const ProductInfo: React.FC = () => {
  const [showAll, setShowAll] = useState(false);
  const { isTablet } = useScreenSize();

  const specs = [
    { label: 'Locatie', value: 'Kortrijk' },
    { label: 'Installatieduur', value: '2 minuten' },
    { label: 'Merk', value: 'LG' },
    { label: 'Type', value: 'Split airco' },
    { label: 'Aantal units', value: '2' },
  ];

  const maxRows = 3;
  const visibleSpecs = showAll ? specs : specs.slice(0, maxRows);

  return (
    <section className={` grid-padding  ${isTablet ? '' : 'mt-min-7'}`}>
      <div className="table-container">
        <h2>
          <span className="tertiary-color">Technische </span>specificaties.
        </h2>

        <table className="spec-table">
          <tbody>
            {visibleSpecs.map((spec, index) => (
              <tr key={index}>
                <th>{spec.label}</th>
                <td>{spec.value}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {!showAll && specs.length > maxRows && (
          <div className="flex-row justify-center pt-1">
            <ButtonMore text="Meer informatie" onClick={() => setShowAll(true)} />
          </div>
        )}
      </div>
    </section>
  );
};

export default ProductInfo;
